<h1 class="mb-2">
  <mdb-icon fas icon="cog"></mdb-icon> Cuentas Bancarias Empresas
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Cuentas Bancarias Empresas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="showNew(); showModalAgregar()" mdbWavesEffect>Agregar</button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <input value="" type="text" id="buscar" class="form-control" [(ngModel)]="nombre" placeholder="Buscar" required #buscar />
          <label for="vecodigo">Buscar</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="obtenerDatosSegunFiltro(nombre)" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>Buscar</button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Banco</th>
            <th scope="col">Tipo de cuenta</th>
            <th scope="col">Nro. de Cuenta</th>
            <th scope="col">Observaciones</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!cuenta_bancariaJoinList || cuenta_bancariaJoinList.length === 0">
            <td colspan="7" style="text-align: center;">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let cue of cuenta_bancariaJoinList">
            <td>{{ cue.nombre_banco }}</td>
            <td>{{ cue.nombre_tipo_cuenta }}</td>
            <td>{{ cue.numero_cuenta }}</td>
            <td>{{ cue.observaciones }}</td>
            <td>
              <div *ngIf="cue.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!cue.activo">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" (click)="showForEdit(cue); showModalModificar()" mdbTooltip="Editar" placement="right"><mdb-icon fas icon="pen"></mdb-icon></button>
              <button *ngIf="cue.activo" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect (click)="permitirCambioEstado(cue)" mdbTooltip="Desactivar" placement="right"><mdb-icon fas icon="ban"></mdb-icon></button>
              <button *ngIf="!cue.activo" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect (click)="permitirCambioEstado(cue)" mdbTooltip="Activar" placement="right"><mdb-icon fas icon="check"></mdb-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar cuenta bancaria -->
<div mdbModal #agregarCuentaBancaria="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formulario" (ngSubmit)="ValidaQueExisteDatosCuenta(); agregarCuentaBancaria.hide();">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarCuentaBancaria.hide()"><span aria-hidden="true">×</span></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de cuenta bancaria</h5>
          </div>
          <div class="col">
            <div class="switch info-switch">
              <label>Inactivo<input formControlName="activo" type="checkbox" color="info" checked /><span class="lever"></span> Activo</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="md-form">
              <mdb-select label="Banco" formControlName="banco" [options]="optionsBanco" placeholder="Banco" [filterEnabled]="true"></mdb-select>
              <div *ngIf="formulario.get('banco').invalid && (formulario.get('banco').dirty || formulario.get('banco').touched)">
                <mdb-error *ngIf="formulario.get('banco').hasError('required')">Por favor seleccione un Banco</mdb-error>
              </div>
            </div>
            <div class="md-form">
              <mdb-select label="Tipo de cuenta" formControlName="tipo_cuenta" [options]="optionsTipoCuenta" [filterEnabled]="true" placeholder="Tipo de cuenta"></mdb-select>
              <div *ngIf="formulario.get('tipo_cuenta').invalid && (formulario.get('tipo_cuenta').dirty || formulario.get('tipo_cuenta').touched)">
                <mdb-error *ngIf="formulario.get('tipo_cuenta').hasError('required')">Por favor seleccione un Banco</mdb-error>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <input value="" formControlName="numero_cuenta" type="text" id="anroCuenta" class="form-control" placeholder="Número de cuenta" required #nroCuenta maxlength="20" />
              <label for="nroCuenta">Número de cuenta</label>
              <div *ngIf="formulario.get('numero_cuenta').invalid && (formulario.get('numero_cuenta').dirty || formulario.get('numero_cuenta').touched)">
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('required')">El Numero de Cuenta es requerido.</mdb-error>
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('maxlength')">El Numero de Cuenta no puede superar los 50 caracteres.</mdb-error>
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('minlength')">El Numero de Cuenta debe tener como mínimo 5 caracteres.</mdb-error>
              </div>
            </div>
            <div class="md-form">
              <input value="" formControlName="observaciones" type="text" id="aobservaciones" class="form-control" placeholder="Observaciones" required #observaciones maxlength="200" />
              <label for="observaciones">Observaciones</label>
              <div *ngIf="formulario.get('observaciones').invalid && (formulario.get('observaciones').dirty || formulario.get('observaciones').touched)">
                <mdb-error *ngIf="formulario.get('observaciones').hasError('required')">La Observacion es requerido.</mdb-error>
                <mdb-error *ngIf="formulario.get('observaciones').hasError('maxlength')">La Observacion no puede superar los 50 caracteres.</mdb-error>
                <mdb-error *ngIf="formulario.get('observaciones').hasError('minlength')">La Observacion debe tener como mínimo 5 caracteres.</mdb-error>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarCuentaBancaria.hide()" mdbWavesEffect>Cerrar</button>
        <button type="submit" class="btn btn-secondary waves-light" [disabled]="formulario.invalid" mdbWavesEffect >Guardar</button>
      </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL Editar cuenta bancaria -->
<div mdbModal #editarCuentaBancaria="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formulario" (ngSubmit)="actualizar(); editarCuentaBancaria.hide();">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="editarCuentaBancaria.hide()"><span aria-hidden="true">×</span></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de cuenta bancaria</h5>
          </div>
          <div class="col">
            <div class="switch info-switch">
              <label>Inactivo<input formControlName="activo" type="checkbox" color="info" checked /><span class="lever"></span> Activo</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="md-form">
              <mdb-select label="Banco" formControlName="banco" [options]="optionsBanco" placeholder="Banco" [filterEnabled]="true"></mdb-select>
              <div *ngIf="formulario.get('banco').invalid && (formulario.get('banco').dirty || formulario.get('banco').touched)">
                <mdb-error *ngIf="formulario.get('banco').hasError('required')">Por favor seleccione un Banco</mdb-error>
              </div>
            </div>
            <div class="md-form">
              <mdb-select label="Tipo de cuenta" formControlName="tipo_cuenta" [options]="optionsTipoCuenta" [filterEnabled]="true" placeholder="Tipo de cuenta"></mdb-select>
              <div *ngIf="formulario.get('tipo_cuenta').invalid && (formulario.get('tipo_cuenta').dirty || formulario.get('tipo_cuenta').touched)">
                <mdb-error *ngIf="formulario.get('tipo_cuenta').hasError('required')">Por favor seleccione un Banco</mdb-error>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <input value="" formControlName="numero_cuenta" type="text" id="enroCuenta" class="form-control" placeholder="Número de cuenta" required #nroCuenta maxlength="20"/>
              <label for="nroCuenta">Número de cuenta</label>
              <div *ngIf="formulario.get('numero_cuenta').invalid && (formulario.get('numero_cuenta').dirty || formulario.get('numero_cuenta').touched)">
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('required')">El Numero de Cuenta es requerido.</mdb-error>
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('maxlength')">El Numero de Cuenta no puede superar los 50 caracteres.</mdb-error>
                <mdb-error *ngIf="formulario.get('numero_cuenta').hasError('minlength')">El Numero de Cuenta debe tener como mínimo 5 caracteres.</mdb-error>
              </div>
            </div>
            <div class="md-form">
              <input value="" formControlName="observaciones" type="text" id="eobservaciones" class="form-control" placeholder="Observaciones" required #observaciones maxlength="200"/>
              <label for="observaciones">Observaciones</label>
              <div *ngIf="formulario.get('observaciones').invalid && (formulario.get('observaciones').dirty || formulario.get('observaciones').touched)">
                <mdb-error *ngIf="formulario.get('observaciones').hasError('required')">La Observacion es requerido.</mdb-error>
                <mdb-error *ngIf="formulario.get('observaciones').hasError('maxlength')">La Observacion no puede superar los 50 caracteres.</mdb-error>
                <mdb-error *ngIf="formulario.get('observaciones').hasError('minlength')">La Observacion debe tener como mínimo 5 caracteres.</mdb-error>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarCuentaBancaria.hide()" mdbWavesEffect>Cerrar</button>
        <button type="submit" class="btn btn-secondary waves-light" [disabled]="formulario.invalid" mdbWavesEffect>Guardar</button>
      </div>
      </form>
    </div>
  </div>
</div>